import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  addPmjayPackage,
  updatePmjayPackage,
  deletePmjayPackage,
} from 'api/pmjay';
import ConfirmModal from "../ConfirmModal/ConfirmModal";

const PMJAY_SPECIALTIES = [
  "Cardiology",
  "Orthopedics",
  "Neurology",
  "Oncology",
  "Urology",
  "Gynecology",
  "Pediatrics",
  "General Surgery",
  "ENT",
  "Ophthalmology",
  "Nephrology",
  "Gastroenterology",
  "Pulmonology",
  "Endocrinology",
  "Dermatology",

  // Add these
  "Burns Management",
  "Emergency Room Packages",
  "High end Diagnostics",
  "High end Medicine",
  "High end procedures",
  "Infectious Diseases",
  "Interventional Radiology",
  "CTVS",
  "General Medicine",
  "Pediatric Medical Management",
  "Pain specialists",
  "Interventional Neuroradiology",
  "General medicine / high end drugs",
  "Medical Rehabilitation",

  "Other",
];

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "55%",
  bgcolor: "background.paper",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
};

const PmjayFormModal = ({ open, onClose, data }) => {
  const [_id, setId] = useState("");
  const [packageCode, setPackageCode] = useState("");
  const [packageName, setPackageName] = useState("");
  const [procedureCode, setProcedureCode] = useState("");
  const [procedureName, setProcedureName] = useState("");
  const [specialty, setSpecialty] = useState("");
  const [specialtyCode, setSpecialtyCode] = useState("");
  const [tier1Amount, setTier1Amount] = useState("");
  const [tier2Amount, setTier2Amount] = useState("");
  const [tier3Amount, setTier3Amount] = useState("");
  const [implantCost, setImplantCost] = useState("");
  const [remarks, setRemarks] = useState("");
  const [status, setStatus] = useState("ACTIVE");
  const [disabled, setDisabled] = useState(true);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const enableBtn = () => setDisabled(false);

  useEffect(() => {
    if (data && Object.entries(data).length > 0) {
      setId(data?._id || "");
      setPackageCode(data?.packageCode || "");
      setPackageName(data?.packageName || "");
      setProcedureCode(data?.procedureCode || "");
      setProcedureName(data?.procedureName || "");
      setSpecialty(data?.specialty || "");
      setSpecialtyCode(data?.specialtyCode || "");
      setTier1Amount(data?.tier1Amount ?? "");
      setTier2Amount(data?.tier2Amount ?? "");
      setTier3Amount(data?.tier3Amount ?? "");
      setImplantCost(data?.implantCost ?? "");
      setRemarks(data?.remarks || "");
      setStatus(data?.status || "ACTIVE");
    }
  }, []);

  const handleSubmit = async () => {
    if (!packageCode || !packageName || !specialty) {
      toast.error("Package Code, Package Name aur Specialty required hai!");
      return;
    }

    setIsApiLoading(true);

    const payload = {
      packageCode,
      packageName,
      procedureCode,
      procedureName,
      specialty,
      specialtyCode,
      tier1Amount: tier1Amount === "" ? null : Number(tier1Amount),
      tier2Amount: tier2Amount === "" ? null : Number(tier2Amount),
      tier3Amount: tier3Amount === "" ? null : Number(tier3Amount),
      implantCost: implantCost === "" ? null : Number(implantCost),
      remarks,
      status,
    };

    try {
      if (_id) {
        await updatePmjayPackage(_id, payload);
        toast.success("PMJAY Package Updated Successfully!");
      } else {
        await addPmjayPackage(payload);
        toast.success("PMJAY Package Added Successfully!");
      }
      setIsApiLoading(false);
      onClose();
    } catch (err) {
      setIsApiLoading(false);
      toast.error(err?.response?.data?.message || "Something went wrong!");
    }
  };

  const handleDelete = async () => {
    try {
      await deletePmjayPackage(_id);
      toast.success("PMJAY Package Deleted Successfully!");
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Delete failed!");
    }
  };

  return (
    <Modal open={open} onClose={() => onClose("close")}>
      <Box sx={modalStyle}>
        {/* Header */}
        <Grid container sx={{ mb: 3 }}>
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Typography variant="h5">
              {_id ? "Edit PMJAY Package" : "Add PMJAY Package"}
            </Typography>

            {_id && (
              <Box
                onClick={() => setDeleteModal(true)}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "30px",
                  height: "30px",
                  bgcolor: "#FFE6F0",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                <svg width={25} height={25} viewBox="0 0 25 25" fill="none">
                  <path
                    d="M10.4941 12.5V17.5"
                    stroke="#F51934"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14.4941 12.5V17.5"
                    stroke="#F51934"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.49414 7.5H20.4941"
                    stroke="#F51934"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6.49414 10.5V18.5C6.49414 20.1569 7.83729 21.5 9.49414 21.5H15.4941C17.151 21.5 18.4941 20.1569 18.4941 18.5V10.5"
                    stroke="#F51934"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9.49414 5.5C9.49414 4.39543 10.3896 3.5 11.4941 3.5H13.4941C14.5987 3.5 15.4941 4.39543 15.4941 5.5V7.5H9.49414V5.5Z"
                    stroke="#F51934"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Box>
            )}
          </Grid>
        </Grid>

        {/* Form */}
        <Grid container spacing={3}>
          <Grid item sm={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Package Code"
              value={packageCode}
              disabled={!!_id}
              onChange={(e) => {
                enableBtn();
                setPackageCode(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Package Name"
              value={packageName}
              onChange={(e) => {
                enableBtn();
                setPackageName(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Procedure Code"
              value={procedureCode}
              onChange={(e) => {
                enableBtn();
                setProcedureCode(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Procedure Name"
              value={procedureName}
              onChange={(e) => {
                enableBtn();
                setProcedureName(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} md={8}>
            <FormControl fullWidth size="small">
              <InputLabel>Specialty</InputLabel>

              <Select
                value={specialty}
                label="Specialty"
                onChange={(e) => {
                  enableBtn();
                  setSpecialty(e.target.value);
                }}
              >
                {PMJAY_SPECIALTIES.map((s) => (
                  <MenuItem key={s} value={s}>
                    {s}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={12} md={4}>
            <TextField
              fullWidth
              size="small"
              label="Specialty Code"
              value={specialtyCode}
              onChange={(e) => {
                enableBtn();
                setSpecialtyCode(e.target.value);
              }}
            />
          </Grid>

          <Grid item sm={12} md={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                label="Status"
                onChange={(e) => {
                  enableBtn();
                  setStatus(e.target.value);
                }}
              >
                <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                <MenuItem value="INACTIVE">INACTIVE</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={12} md={4}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label="Tier 1 Amount (₹)"
              value={tier1Amount}
              onChange={(e) => {
                enableBtn();
                setTier1Amount(e.target.value);
              }}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item sm={12} md={4}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label="Tier 2 Amount (₹)"
              value={tier2Amount}
              onChange={(e) => {
                enableBtn();
                setTier2Amount(e.target.value);
              }}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item sm={12} md={4}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label="Tier 3 Amount (₹)"
              value={tier3Amount}
              onChange={(e) => {
                enableBtn();
                setTier3Amount(e.target.value);
              }}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item sm={12} md={6}>
            <TextField
              fullWidth
              size="small"
              type="number"
              label="Implant Cost (₹)"
              value={implantCost}
              onChange={(e) => {
                enableBtn();
                setImplantCost(e.target.value);
              }}
              inputProps={{ min: 0 }}
            />
          </Grid>

          <Grid item sm={12} md={6}>
            <TextField
              fullWidth
              size="small"
              label="Remarks"
              value={remarks}
              onChange={(e) => {
                enableBtn();
                setRemarks(e.target.value);
              }}
            />
          </Grid>
        </Grid>

        {/* Footer */}
        <Grid item display="flex" justifyContent="right" sx={{ mt: 3 }}>
          <Button
            sx={{
              marginRight: "15px",
              bgcolor: "white",
              border: "1px solid #194AF5",
              color: "#194AF5",
              padding: "0.25rem 1.5rem",
              boxShadow: "none",
              ":hover": {
                bgcolor: "white",
                border: "1px solid #194AF5",
                boxShadow: "none",
              },
            }}
            variant="contained"
            onClick={() => onClose("close")}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={disabled || isApiLoading}
            onClick={handleSubmit}
            sx={{ padding: "0.25rem 1.5rem", boxShadow: "none" }}
          >
            {isApiLoading ? "Saving..." : "Save"}
          </Button>
        </Grid>

        <ConfirmModal
          open={deleteModal}
          type="pmjay"
          close={() => setDeleteModal(false)}
          confirm={() => {
            handleDelete();
            setDeleteModal(false);
          }}
        />
      </Box>
    </Modal>
  );
};

export default PmjayFormModal;
